import { Pipe, PipeTransform } from '@angular/core';

import { Account } from '@stores/models/app/account';

@Pipe({ name: 'accountDisplayName', standalone: true })
export class AccountDisplayNamePipe implements PipeTransform {
  transform(
    account: Account | null | undefined,
    initialsOnly = false
  ): string | null {
    if (!account) {
      return null;
    }

    return initialsOnly
      ? this.getInitials(account)
      : `${account.firstName} ${account.lastName}`;
  }

  private getInitials(account: Account): string {
    const firstName = account.firstName?.[0] ?? '';
    const lastName = account.lastName?.[0] ?? '';

    return `${firstName}${lastName}`;
  }
}
